// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   react-big-calendar skin, shared by appointments, shift planning
   and employee shifts. Page CSS only adds layout specifics.
   ============================================================ */
.rbc-calendar {
  font-family: var(--ds-font);
  color: var(--ds-text);
}

/* Toolbar: period label as a heading, button groups as segmented controls */
.rbc-calendar .rbc-toolbar {
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-3) !important;
}

.rbc-calendar .rbc-toolbar .rbc-toolbar-label {
  font-family: var(--ds-font-display);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--ds-heading);
}

.rbc-calendar .rbc-toolbar .rbc-btn-group {
  display: inline-flex;
  padding: 3px;
  gap: 2px;
  border-radius: 12px;
  background: var(--ds-surface-muted);
}

.rbc-calendar .rbc-toolbar .rbc-btn-group > button,
.rbc-calendar .rbc-toolbar button {
  min-height: 36px;
  padding: 0 14px;
  border: 0 !important;
  border-radius: 9px !important;
  background: transparent;
  color: var(--ds-text-2);
  font-weight: 600;
  font-size: 0.85rem;
  box-shadow: none !important;
  cursor: pointer;
}

.rbc-calendar .rbc-toolbar button:hover,
.rbc-calendar .rbc-toolbar button:focus {
  background: rgba(255, 255, 255, 0.7);
  color: var(--ds-heading);
}

.rbc-calendar .rbc-toolbar button.rbc-active,
.rbc-calendar .rbc-toolbar button.rbc-active:hover,
.rbc-calendar .rbc-toolbar button:active {
  background: var(--ds-surface) !important;
  color: var(--ds-brand-strong) !important;
  box-shadow: var(--ds-shadow-xs) !important;
}

/* Grid */
.rbc-calendar .rbc-month-view,
.rbc-calendar .rbc-time-view,
.rbc-calendar .rbc-agenda-view table.rbc-agenda-table {
  border-color: var(--ds-border-soft) !important;
  border-radius: 12px;
  overflow: hidden;
  background: var(--ds-surface);
}

.rbc-calendar .rbc-header {
  padding: 8px 4px !important;
  border-color: var(--ds-border-soft) !important;
  background: var(--ds-surface-2) !important;
  color: var(--ds-text-2) !important;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.rbc-calendar .rbc-month-header,
.rbc-calendar .rbc-time-header-cell {
  background: var(--ds-surface-2) !important;
  color: var(--ds-text-2) !important;
}

.rbc-calendar .rbc-day-bg + .rbc-day-bg,
.rbc-calendar .rbc-month-row + .rbc-month-row,
.rbc-calendar .rbc-time-content,
.rbc-calendar .rbc-time-content > * + * > *,
.rbc-calendar .rbc-timeslot-group,
.rbc-calendar .rbc-time-header-content,
.rbc-calendar .rbc-day-slot .rbc-time-slot,
.rbc-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td,
.rbc-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {
  border-color: var(--ds-border-soft) !important;
}

.rbc-calendar .rbc-off-range-bg {
  background: var(--ds-surface-2) !important;
}

.rbc-calendar .rbc-off-range {
  color: var(--ds-text-muted);
}

.rbc-calendar .rbc-date-cell {
  padding: 6px 8px 0 !important;
  font-size: 0.8rem;
  font-weight: 500;
}

.rbc-calendar .rbc-today {
  background: var(--ds-brand-50) !important;
}

.rbc-calendar .rbc-date-cell.rbc-now > * {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 4px;
  border-radius: 999px;
  background: var(--ds-brand);
  color: #fff;
  font-weight: 700;
}

.rbc-calendar .rbc-time-gutter,
.rbc-calendar .rbc-time-header-gutter {
  background: var(--ds-surface) !important;
  color: var(--ds-text-2);
  font-size: 0.75rem;
}

.rbc-calendar .rbc-current-time-indicator {
  background: var(--ds-danger);
  height: 2px;
}

/* Events */
.rbc-calendar .rbc-event,
.rbc-calendar .rbc-day-slot .rbc-background-event {
  border: 0 !important;
  border-radius: 8px !important;
  padding: 3px 8px !important;
  font-size: 0.8rem;
  font-weight: 500;
  box-shadow: 0 1px 2px rgba(19, 33, 44, 0.12);
}

.rbc-calendar .rbc-event:not([style*="background"]) {
  background: var(--ds-brand);
}

.rbc-calendar .rbc-event.rbc-selected {
  box-shadow:
    0 0 0 2px var(--ds-surface),
    0 0 0 4px var(--ds-brand-400) !important;
}

.rbc-calendar .rbc-show-more {
  color: var(--ds-brand-strong);
  font-weight: 600;
  background: transparent;
}

.rbc-calendar .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  padding: 10px 12px;
  background: var(--ds-surface-2);
  color: var(--ds-text-2);
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-color: var(--ds-border-soft);
}

.rbc-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
  padding: 10px 12px;
}

@media (max-width: 767.98px) {
  .rbc-calendar .rbc-toolbar .rbc-btn-group {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/design-system/calendar.css"],"names":[],"mappings":"AAAA;;;iEAGiE;AACjE;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,4EAA4E;AAC5E;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,QAAQ;EACR,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;;;EAGE,wCAAwC;EACxC,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA,SAAS;AACT;;;EAGE,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,0CAA0C;EAC1C,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;;;;;;;;;EASE,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,wCAAwC;EACxC,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA,WAAW;AACX;;EAEE,oBAAoB;EACpB,6BAA6B;EAC7B,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;;4CAE0C;AAC5C;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":["/* ============================================================\n   react-big-calendar skin, shared by appointments, shift planning\n   and employee shifts. Page CSS only adds layout specifics.\n   ============================================================ */\n.rbc-calendar {\n  font-family: var(--ds-font);\n  color: var(--ds-text);\n}\n\n/* Toolbar: period label as a heading, button groups as segmented controls */\n.rbc-calendar .rbc-toolbar {\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-3) !important;\n}\n\n.rbc-calendar .rbc-toolbar .rbc-toolbar-label {\n  font-family: var(--ds-font-display);\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--ds-heading);\n}\n\n.rbc-calendar .rbc-toolbar .rbc-btn-group {\n  display: inline-flex;\n  padding: 3px;\n  gap: 2px;\n  border-radius: 12px;\n  background: var(--ds-surface-muted);\n}\n\n.rbc-calendar .rbc-toolbar .rbc-btn-group > button,\n.rbc-calendar .rbc-toolbar button {\n  min-height: 36px;\n  padding: 0 14px;\n  border: 0 !important;\n  border-radius: 9px !important;\n  background: transparent;\n  color: var(--ds-text-2);\n  font-weight: 600;\n  font-size: 0.85rem;\n  box-shadow: none !important;\n  cursor: pointer;\n}\n\n.rbc-calendar .rbc-toolbar button:hover,\n.rbc-calendar .rbc-toolbar button:focus {\n  background: rgba(255, 255, 255, 0.7);\n  color: var(--ds-heading);\n}\n\n.rbc-calendar .rbc-toolbar button.rbc-active,\n.rbc-calendar .rbc-toolbar button.rbc-active:hover,\n.rbc-calendar .rbc-toolbar button:active {\n  background: var(--ds-surface) !important;\n  color: var(--ds-brand-strong) !important;\n  box-shadow: var(--ds-shadow-xs) !important;\n}\n\n/* Grid */\n.rbc-calendar .rbc-month-view,\n.rbc-calendar .rbc-time-view,\n.rbc-calendar .rbc-agenda-view table.rbc-agenda-table {\n  border-color: var(--ds-border-soft) !important;\n  border-radius: 12px;\n  overflow: hidden;\n  background: var(--ds-surface);\n}\n\n.rbc-calendar .rbc-header {\n  padding: 8px 4px !important;\n  border-color: var(--ds-border-soft) !important;\n  background: var(--ds-surface-2) !important;\n  color: var(--ds-text-2) !important;\n  font-size: 0.72rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.rbc-calendar .rbc-month-header,\n.rbc-calendar .rbc-time-header-cell {\n  background: var(--ds-surface-2) !important;\n  color: var(--ds-text-2) !important;\n}\n\n.rbc-calendar .rbc-day-bg + .rbc-day-bg,\n.rbc-calendar .rbc-month-row + .rbc-month-row,\n.rbc-calendar .rbc-time-content,\n.rbc-calendar .rbc-time-content > * + * > *,\n.rbc-calendar .rbc-timeslot-group,\n.rbc-calendar .rbc-time-header-content,\n.rbc-calendar .rbc-day-slot .rbc-time-slot,\n.rbc-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td,\n.rbc-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {\n  border-color: var(--ds-border-soft) !important;\n}\n\n.rbc-calendar .rbc-off-range-bg {\n  background: var(--ds-surface-2) !important;\n}\n\n.rbc-calendar .rbc-off-range {\n  color: var(--ds-text-muted);\n}\n\n.rbc-calendar .rbc-date-cell {\n  padding: 6px 8px 0 !important;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.rbc-calendar .rbc-today {\n  background: var(--ds-brand-50) !important;\n}\n\n.rbc-calendar .rbc-date-cell.rbc-now > * {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 24px;\n  height: 24px;\n  padding: 0 4px;\n  border-radius: 999px;\n  background: var(--ds-brand);\n  color: #fff;\n  font-weight: 700;\n}\n\n.rbc-calendar .rbc-time-gutter,\n.rbc-calendar .rbc-time-header-gutter {\n  background: var(--ds-surface) !important;\n  color: var(--ds-text-2);\n  font-size: 0.75rem;\n}\n\n.rbc-calendar .rbc-current-time-indicator {\n  background: var(--ds-danger);\n  height: 2px;\n}\n\n/* Events */\n.rbc-calendar .rbc-event,\n.rbc-calendar .rbc-day-slot .rbc-background-event {\n  border: 0 !important;\n  border-radius: 8px !important;\n  padding: 3px 8px !important;\n  font-size: 0.8rem;\n  font-weight: 500;\n  box-shadow: 0 1px 2px rgba(19, 33, 44, 0.12);\n}\n\n.rbc-calendar .rbc-event:not([style*=\"background\"]) {\n  background: var(--ds-brand);\n}\n\n.rbc-calendar .rbc-event.rbc-selected {\n  box-shadow:\n    0 0 0 2px var(--ds-surface),\n    0 0 0 4px var(--ds-brand-400) !important;\n}\n\n.rbc-calendar .rbc-show-more {\n  color: var(--ds-brand-strong);\n  font-weight: 600;\n  background: transparent;\n}\n\n.rbc-calendar .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  padding: 10px 12px;\n  background: var(--ds-surface-2);\n  color: var(--ds-text-2);\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-color: var(--ds-border-soft);\n}\n\n.rbc-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n  padding: 10px 12px;\n}\n\n@media (max-width: 767.98px) {\n  .rbc-calendar .rbc-toolbar .rbc-btn-group {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
